// Stable no-op header button placeholders. Always providing a component
// reference (instead of undefined) prevents React Navigation's HeaderConfig
// from hitting a hooks-order mismatch when a header button appears/disappears
// between renders, while keeping the component references stable avoids
// creating new component types during render.
export function HeaderRightEmpty() {
  return null;
}

export function HeaderLeftEmpty() {
  return null;
}
